import React, { useState } from "react";
import monstersData from "./monsters.json";
import Formulas from "./Formulas";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// --- REUSABLE UI COMPONENTS (Moved outside to prevent re-rendering bugs) ---
const InputGroup = ({ label, type = "number", value, onChange, disabled=false }) => (
    <div className="rpg-input-group">
        <label className="rpg-label">{label}</label>
        <input className="rpg-input" type={type} value={value} onChange={onChange} disabled={disabled} />
    </div>
);

const ActionButton = ({ onClick, label, disabled, colorClass = "primary" }) => (
    <div className="w-[90%] mt-4 mb-4">
        <button
            disabled={disabled}
            onClick={onClick}
            className={`rpg-btn ${colorClass} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
            {label || "CALCULATE"}
        </button>
    </div>
);


const Main = ({ page, themeClass, resultN, changeTheme }) => {
  const [attackType, setAttackType] = useState("auto");
  const [classm, setClassm] = useState("melee");
  const [base, setBase] = useState("");
  const [armour, setArmour] = useState("");
  const [afkBase, setAfkBase] = useState("");
  const [afkStat, setAfkStat] = useState("");
  const [afkWeaponAtk, setAfkWeaponAtk] = useState("");
  const [goalLevel, setGoalLevel] = useState("");
  const [grindrate, setGrindrate] = useState("");
  const buffs = "0";
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [weaponAtk, setWeaponAtk] = useState("");
  const tick = "4";
  const [basegoal, setBasegoal] = useState("");
  const [stat, setStat] = useState("");
  const [mobId, setMobId] = useState("");
  const [result, setResult] = useState("");
  const [currentStat, setCurrentStat] = useState("");
  const [defence, setDefence] = useState("");
  const [goalStat, setGoalstat] = useState("");
  const [hours, setHours] = useState("");
  const [stat1, setStat1] = useState(50);
  const [stat2, setStat2] = useState(100);
  const [numpots, setNumpots] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  
  // State for buffs in Stat calculator
  const [bonusStamina, setBonusStamina] = useState(false);
  const [onlineTraining, setOnlineTraining] = useState(false);
  const [doubleSkillPotion, setDoubleSkillPotion] = useState(false);

  // State for the new Simulator
  const [vampKills, setVampKills] = useState("");
  const [drowKills, setDrowKills] = useState("");
  const [lizKills, setLizKills] = useState("");


  const handleMonsterChange = (event) => {
    setMobId(event.target.value);
  };

  function skull(currLevel) {
    const levelNum = parseInt(currLevel, 10);
    const result =
      `-- SKULL COST ANALYSIS (LVL ${levelNum.toLocaleString()}) --\n\n` +
      `Yellow Skull Gold: --${(150 * levelNum).toLocaleString()}-- 🔥 | Lost: --${(150 * levelNum).toLocaleString()}-- 🔻\n\n` +
      `Orange Skull Gold: --${(150 * 4 * levelNum).toLocaleString()}-- 🔥 | Lost: --${(150 * 3 * levelNum).toLocaleString()}-- 🔻\n\n` +
      `Red Skull Gold: --${(150 * 13 * levelNum).toLocaleString()}-- 🔥 | Lost: --${(150 * 9 * levelNum).toLocaleString()}-- 🔻\n\n` +
      `Black Skull Gold: --${(150 * 40 * levelNum).toLocaleString()}-- 🔥 | Bounty: --${(150 * 27 * levelNum).toLocaleString()}-- 🔻\n\n` +
      `Black Skull x2 Gold: --${(150 * 121 * levelNum).toLocaleString()}-- 🔥 | Bounty: --${(150 * 81 * levelNum).toLocaleString()}-- 🔻\n\n` +
      `Black Skull x3 Gold: --${(150 * 364 * levelNum).toLocaleString()}-- 🔥 | Bounty: --${(150 * 243 * levelNum).toLocaleString()}-- 🔻\n\n` +
      `Black Skull x4 Gold: --${(150 * 1093 * levelNum).toLocaleString()}-- 🔥 | Bounty: --${(150 * 729 * levelNum).toLocaleString()}-- 🔻\n\n` +
      `Black Skull x5 Gold: --${(150 * 3280 * levelNum).toLocaleString()}-- 🔥 | Bounty: --${(150 * 2187 * levelNum).toLocaleString()}-- 🔻`;
    setResult(result);
    setOpenDialog(true);
  }

  function handleCalculateClick() {
    if(!base || !stat || !weaponAtk || !mobId) {
        setResult("Error: Please fill all fields.");
        setOpenDialog(true);
        return;
    }
    const baseNum = parseInt(base, 10);
    const statNum = parseInt(stat, 10);
    const weaponAtkNum = parseInt(weaponAtk, 10);

    const header = `Base: ${baseNum} | Stat: ${statNum} | Weapon: ${weaponAtkNum} Atk\n`;

    let attackTypeString = "";
    let minRawDamage, maxRawDamage;

    if (attackType === "auto") {
      minRawDamage = Formulas.autoMinRawDamageCalc(statNum, weaponAtkNum, baseNum);
      maxRawDamage = Formulas.autoMaxRawDamageCalc(statNum, weaponAtkNum, baseNum);
      attackTypeString = "Auto";
    } else if (attackType === "magic") {
      minRawDamage = Formulas.specialMagicMinRawDamageCalc(statNum, weaponAtkNum, baseNum);
      maxRawDamage = Formulas.specialMagicMaxRawDamageCalc(statNum, weaponAtkNum, baseNum);
      attackTypeString = "Special";
    } else {
      minRawDamage = Formulas.specialMeldistMinRawDamageCalc(statNum, weaponAtkNum, baseNum);
      maxRawDamage = Formulas.specialMeldistMaxRawDamageCalc(statNum, weaponAtkNum, baseNum);
      attackTypeString = "Special";
    }

    const maxRawCritDamage = Formulas.maxRawCritDamageCalc(maxRawDamage);
    const minDamage = Formulas.minDamageCalc(minRawDamage, monstersData[mobId].defence);
    const maxDamage = Formulas.maxDamageCalc(maxRawDamage, monstersData[mobId].defence);
    const maxCritDamage = Formulas.maxCritDamageCalc(maxRawCritDamage, monstersData[mobId].defence);
    const normalAccuracy = Formulas.normalAccuracyCalc(maxRawDamage, minRawDamage, monstersData[mobId].defence);
    const critAccuracy = Formulas.critAccuracyCalc(maxRawCritDamage, maxRawDamage, monstersData[mobId].defence);
    const str0 = `Target: --${monstersData[mobId].monster}--\n\n`;
    let str1 = "";
    let str2 = "";

    if (normalAccuracy === 1.0) {
      str1 = `Min. Damage (${attackTypeString}): --${parseInt(minDamage)}--\nMax. Damage (${attackTypeString}): --${parseInt(maxDamage)}--\n`;
    } else if (normalAccuracy > 0) {
      str1 = `Max. Damage (${attackTypeString}): --${parseInt(maxDamage)}--\n`;
    } else {
      str1 = "You aren't strong enough to deal normal damage to this mob.\n";
    }

    if (critAccuracy > 0) {
      str2 = `Maximum Critical Damage (${attackTypeString}): --${parseInt(maxCritDamage)}--\n`;
    } else {
      str2 = "You aren't strong enough to deal critical damage to this mob.\n";
    }

    const result = `-- ${attackTypeString.toUpperCase()} DAMAGE --\n${header}\n${str0}${str1}${str2}`;
    setResult(result);
    setOpenDialog(true);
  }

  function handleGrind(base1, base2, grindRate) {
    const base1Num = parseInt(base1, 10);
    const base2Num = parseInt(base2, 10);
    const grindRateNum = parseInt(grindRate, 10);
    
    let result = "";
    if (base1Num > base2Num) {
      result = "Goal level must be greater than current level";
    } else {
      let expNeeded = Formulas.expCalc(base2Num) - Formulas.expCalc(base1Num);
      const minutesNeeded = (60 * expNeeded) / grindRateNum;
      const hoursNeeded = minutesNeeded / 60;
      result =
        `-- GRINDING REPORT --\n` +
        `From Lvl ${base1Num.toLocaleString()} to ${base2Num.toLocaleString()} at ${grindRateNum.toLocaleString()} Exp/Hour\n\n` +
        `Total Exp Needed: --${expNeeded.toLocaleString(undefined, { maximumFractionDigits: 0 })}-- 🔥\n\n` +
        `Estimated Time:\n` +
        `--${minutesNeeded.toLocaleString(undefined, { maximumFractionDigits: 0 })}-- minutes\n` +
        `--${hoursNeeded.toLocaleString(undefined, { maximumFractionDigits: 0 })}-- hours`;
    }
    setResult(result);
    setOpenDialog(true);
  }

  function ptrain(classtype, base, stat, buff, weaponatk, tick) {
    if(!base || !stat || !weaponatk) {
         setResult("Fill all fields");
         setOpenDialog(true);
         return;
    }
    const baseNum = parseInt(base, 10);
    const statNum = parseInt(stat, 10);
    const weaponAtkNum = parseInt(weaponatk, 10);
    const tickNum = parseInt(tick, 10);
    
    let str0 = "", str1 = "", str2 = "", str3 = "", str4 = "", classEmoji = "";
    let maxRawDamage, minRawDamage;

    if (classtype === "magic") {
        minRawDamage = Formulas.specialMagicMinRawDamageCalc(statNum, weaponAtkNum, baseNum);
        maxRawDamage = Formulas.specialMagicMaxRawDamageCalc(statNum, weaponAtkNum, baseNum);
        classEmoji = "Magic 🔥";
    } else if (classtype === "melee") {
        minRawDamage = Formulas.specialMeldistMinRawDamageCalc(statNum, weaponAtkNum, baseNum);
        maxRawDamage = Formulas.specialMeldistMaxRawDamageCalc(statNum, weaponAtkNum, baseNum);
        classEmoji = "Melee ⚔️";
    } else { // distance
        minRawDamage = Formulas.specialDist4arrowMinRawDamageCalc(statNum, weaponAtkNum, baseNum);
        maxRawDamage = Formulas.specialDist4arrowMaxRawDamageCalc(statNum, weaponAtkNum, baseNum);
        classEmoji = "Distance 🏹";
    }
    const header = `Base: ${baseNum} | Stat: ${statNum} | Weapon: ${weaponAtkNum} Atk | Class: ${classEmoji} | Tick: ${tickNum}\n`;
    const maxRawCritDamage = Formulas.maxRawCritDamageCalc(maxRawDamage);
    let accuracy = 0;
    let pos = 0;
    const threshold = Formulas.thresholdCalc(tickNum);

    for (let x = monstersData.length - 1; x >= 0; x--) {
      if ([13, 19, 20, 22, 24, 25, 26, 29, 31, 33, 36, 37].includes(x) || x >= 39) continue;
      const mobDefense = monstersData[x].defence;
      accuracy = Formulas.accuracyCalc(maxRawCritDamage, maxRawDamage, minRawDamage, mobDefense);
      if (accuracy >= threshold) {
        pos = x;
        break;
      }
    }

    const minDamage = Formulas.minDamageCalc(minRawDamage, monstersData[pos].defence);
    const maxDamage = Formulas.maxDamageCalc(maxRawDamage, monstersData[pos].defence);
    const maxCritDamage = Formulas.maxCritDamageCalc(maxRawCritDamage, monstersData[pos].defence);
    const avgdmg = Formulas.averageDamageCalc(accuracy, maxDamage, minDamage, maxCritDamage);
    const totalaccuracy = Formulas.totalAccuracyCalc(accuracy, tickNum);
    const maxtickrate = Formulas.maxTickrateCalc(tickNum);
    const powertickrate = Formulas.powerTickrateCalc(totalaccuracy, maxtickrate);
    const time = Formulas.timeToKillCalc(avgdmg, pos);

    str0 = `You can power train on --${monstersData[pos].monster}--!\n`;

    let statadd = 0, checked = false, alrdealdamage = false, dealdamage = false;
    let newMaxDamage, newaccuracy = 0;
    let newpos = parseInt(pos, 10) + 1;

    while (true) {
      if ([13, 19, 20, 22, 24, 25, 26, 29, 31, 33, 36, 37].includes(newpos)) newpos++;
      else if (newpos >= 38) { newpos = 38; break; } 
      else break;
    }
    const checknextmob = pos !== 38;

    while (newaccuracy < threshold && checknextmob) {
      const statneeded = statNum + statadd;
      let newMaxRawDamage, newMinRawDamage;

      if (classtype === "magic") {
        newMinRawDamage = Formulas.specialMagicMinRawDamageCalc(statneeded, weaponAtkNum, baseNum);
        newMaxRawDamage = Formulas.specialMagicMaxRawDamageCalc(statneeded, weaponAtkNum, baseNum);
      } else if (classtype === "melee") {
        newMinRawDamage = Formulas.specialMeldistMinRawDamageCalc(statneeded, weaponAtkNum, baseNum);
        newMaxRawDamage = Formulas.specialMeldistMaxRawDamageCalc(statneeded, weaponAtkNum, baseNum);
      } else {
        newMinRawDamage = Formulas.specialDist4arrowMinRawDamageCalc(statneeded, weaponAtkNum, baseNum);
        newMaxRawDamage = Formulas.specialDist4arrowMaxRawDamageCalc(statneeded, weaponAtkNum, baseNum);
      }
      const newMaxRawCritDamage = Formulas.maxRawCritDamageCalc(newMaxRawDamage);
      newMaxDamage = Formulas.maxDamageCalc(newMaxRawDamage, monstersData[newpos].defence);
      newaccuracy = Formulas.accuracyCalc(newMaxRawCritDamage, newMaxRawDamage, newMinRawDamage, monstersData[newpos].defence);
      if (newMaxDamage >= 1 && !checked) {
        str4 = `You can deal --${Math.floor(newMaxDamage)}-- max damage to --${monstersData[newpos].monster}--!`;
        alrdealdamage = true;
      } else if (newMaxDamage > 1 && !alrdealdamage && !dealdamage) {
        str4 = `You can deal --${Math.floor(newMaxDamage)}-- max damage to --${monstersData[newpos].monster}-- in --${statadd} stats--!`;
        dealdamage = true;
      }
      checked = true;
      statadd++;
    }

    if (checknextmob) {
      str1 = `Max. Damage: --${Math.floor(maxDamage)}-- | Tickrate: --${Math.floor(powertickrate)}-- / ${Math.floor(maxtickrate)}\n`;
      str2 = `Avg. time to kill ${monstersData[pos].monster}: --${Math.floor(time / 60)} min. ${Math.floor(time % 60)} sec.--\n`;
      str3 = `You need --${statadd} more stats-- to PT effectively on --${monstersData[newpos].monster}--!\n`;
    } else {
      str1 = `Min. Damage: --${Math.floor(minDamage)}-- | Max. Damage: --${Math.floor(maxDamage)}--\n`;
      str2 = `Avg. time to kill ${monstersData[pos].monster}: --${Math.floor(time / 60)} min. ${Math.floor(time % 60)} sec.--\n`;
    }
    setResult(`-- POWER TRAINING ANALYSIS --\n${header}\n${str0}${str1}${str2}${str3}${str4}`);
    setOpenDialog(true);
  }

  function calculateStat(stat1, stat2, bonusStamina, onlineTraining, doubleSkillPotion) {
    const stat1Num = parseInt(stat1, 10);
    const stat2Num = parseInt(stat2, 10);

    if (stat1Num > stat2Num) return "Goal stat must be greater than current stat";
    
    let ticks1 = stat1Num <= 54 ? Formulas.stat0to54Calc(stat1Num) : Formulas.stat55to99Calc(stat1Num);
    let ticks2 = stat2Num <= 54 ? Formulas.stat0to54Calc(stat2Num) : Formulas.stat55to99Calc(stat2Num);
    const totalTicks = ticks2 - ticks1;
    
    const formatDuration = (minutes) => {
        if (minutes < 1) {
            return `${(minutes * 60).toFixed(0)} seconds`;
        }
        if (minutes >= 60) {
            const hours = minutes / 60;
            return `${hours.toFixed(1)} hours`;
        }
        return `${minutes.toFixed(1)} minutes`;
    };

    const baseAfkRate = 3600; // ticks per hour
    const basePtRate = 14400; // ticks per hour
    
    const baseAfkMinutes = (totalTicks / baseAfkRate) * 60;
    const basePtMinutes = (totalTicks / basePtRate) * 60;

    let resultString = `Initial Stat: ${stat1Num.toLocaleString()} | Goal Stat: ${stat2Num.toLocaleString()}\nNeed approx --${Math.round(totalTicks).toLocaleString()} ticks!--\n\n`;
    
    resultString += `-- Without Buffs --\n`;
    resultString += `AFK Training: --${formatDuration(baseAfkMinutes)}--\n`;
    resultString += `Power Training (4-tick): --${formatDuration(basePtMinutes)}--\n\n`;

    let multiplier = 1.0;
    if (bonusStamina) multiplier += 0.5;
    if (onlineTraining) multiplier += 1.0;
    if (doubleSkillPotion) multiplier += 1.0;

    if (multiplier > 1) {
        const buffedAfkRate = baseAfkRate * multiplier;
        const buffedPtRate = basePtRate * multiplier;
        const buffedAfkMinutes = (totalTicks / buffedAfkRate) * 60;
        const buffedPtMinutes = (totalTicks / buffedPtRate) * 60;

        resultString += `-- With Selected Buffs (${multiplier.toFixed(1)}x) ---\n`;
        resultString += `AFK Training: --${formatDuration(buffedAfkMinutes)}--\n`;
        resultString += `Power Training (4-tick): --${formatDuration(buffedPtMinutes)}--\n\n`;
    }

    const totalManaNeeded = (totalTicks / 4) * 50;
    const potInfo = [
        { name: "Mana Potions", mana: 100, cost: 50 },       // Avg of 80-120
        { name: "Greater Potions", mana: 240, cost: 150 },   // Avg of 200-280
        { name: "Super Potions", mana: 450, cost: 350 },     // Avg of 380-520
        { name: "Ultimate Potions", mana: 735, cost: 650 }   // Avg of 650-820
    ];

    resultString += `-- PT GOLD COST --\n(Assumes Melee/Dist 50 mana/special)\n`;

    potInfo.forEach(pot => {
        const numPotsNeeded = Math.ceil(totalManaNeeded / pot.mana);
        const totalGoldCost = numPotsNeeded * pot.cost;
        resultString += `${pot.name}: --${numPotsNeeded.toLocaleString()}-- pots (~${totalGoldCost.toLocaleString()} gold)\n`;
    });

    return resultString;
  }

  function exp(currLevel) {
    const levelNum = parseInt(currLevel, 10);
    const nextLevelNum = levelNum + 1;
    
    const currentExp = Formulas.expCalc(levelNum);
    const nextLevelExp = Formulas.expCalc(nextLevelNum);
    const expNeeded = nextLevelExp - currentExp;
    const expLost = expNeeded / 6.6;
    setResult(`-- EXP FOR LEVEL ${levelNum.toLocaleString()} --\n\n` +
      `Current Total Exp: --${currentExp.toLocaleString(undefined,{maximumFractionDigits: 0,})}--\n` +
      `Exp to Level ${nextLevelNum.toLocaleString()}: --${expNeeded.toLocaleString(undefined, {maximumFractionDigits: 0,})}--\n` + 
      `Exp lost on death: --${expLost.toLocaleString(undefined, {maximumFractionDigits: 0,})}--`);
      setOpenDialog(true);
  }

  function potions(numpots) {
    const potsNum = parseInt(numpots, 10);
    setResult(
      `-- POTION COST (${potsNum.toLocaleString()} pots) --\n\n` +
      `Mana Potion: --${(potsNum * 50).toLocaleString()} gold--\n` +
      `Greater Potion: --${(potsNum * 150).toLocaleString()} gold--\n` +
      `Super Potion: --${(potsNum * 350).toLocaleString()} gold--\n` +
      `Ultimate Potion: --${(potsNum * 650).toLocaleString()} gold--`
    );
    setOpenDialog(true);
  }

  function train(base, stat, weaponatk) {
    if(!base || !stat || !weaponatk) {
         setResult("Fill all fields");
         setOpenDialog(true);
         return;
    }
    const baseNum = parseInt(base, 10);
    const statNum = parseInt(stat, 10);
    const weaponAtkNum = parseInt(weaponatk, 10);
    
    const slimeLordEmoji = ""; 
    const header = `Base: ${baseNum} ${slimeLordEmoji} Stat: ${statNum} ${slimeLordEmoji} Weapon: ${weaponAtkNum} Atk\n`;
    let str0 = "", str1 = "", str2 = "", str3 = "", str4 = "", str5 = "";
    const minRawDamage = Formulas.autoMinRawDamageCalc(statNum, weaponAtkNum, baseNum);
    const maxRawDamage = Formulas.autoMaxRawDamageCalc(statNum, weaponAtkNum, baseNum);
    const maxRawCritDamage = Formulas.maxRawCritDamageCalc(maxRawDamage);
    let accuracy = 0, pos = 0;

    for (let x = monstersData.length - 1; x >= 0; x--) {
      if (x === 26 || x === 31) continue;
      accuracy = Formulas.accuracyCalc(maxRawCritDamage, maxRawDamage, minRawDamage, monstersData[x].defence);
      if (accuracy >= 0.1749) {
        pos = x; break;
      }
    }

    const minDamage = Formulas.minDamageCalc(minRawDamage, monstersData[pos].defence);
    const maxDamage = Formulas.maxDamageCalc(maxRawDamage, monstersData[pos].defence);
    const maxCritDamage = Formulas.maxCritDamageCalc(maxRawCritDamage, monstersData[pos].defence);
    const avgDmg = Formulas.averageDamageCalc(accuracy, maxDamage, minDamage, maxCritDamage);
    const tickRate = Formulas.tickrateCalc(accuracy, 3600);

    let oneMob = true, checkNextMob = true, newPos = pos + 1;
    if ([5, 20, 22, 28, 30].includes(pos)) { pos--; oneMob = false; }
    if (newPos > 40) checkNextMob = false;
    if (newPos === 26 || newPos === 31) newPos++;
    let time = Formulas.timeToKillCalc(avgDmg, pos);

    str0 = `You can train effectively on --${monstersData[pos].monster}--!\n`;
    if (!oneMob) {
      let time2 = Formulas.timeToKillCalc(avgDmg, pos + 1);
      str0 = `You can train effectively on --${monstersData[pos].monster}-- & --${monstersData[pos + 1].monster}--!\n`;
      str3 = `Avg. time to kill ${monstersData[pos + 1].monster}: --${Math.floor(time2 / 60)} min. ${Math.floor(time2 % 60)} sec.--\n`;
    }

    let statAdd = 0, checked = false, alrDealDamage = false, dealDamage = false, newMaxDamage, newAccuracy = 0;
    while (newAccuracy < 0.1749 && checkNextMob) {
      const statNeeded = statNum + statAdd;
      const newMinRawDamage = Formulas.autoMinRawDamageCalc(statNeeded, weaponAtkNum, baseNum);
      const newMaxRawDamage = Formulas.autoMaxRawDamageCalc(statNeeded, weaponAtkNum, baseNum);
      const newMaxRawCritDamage = Formulas.maxRawCritDamageCalc(newMaxRawDamage);
      newMaxDamage = Formulas.maxDamageCalc(newMaxRawDamage, monstersData[newPos].defence);
      newAccuracy = Formulas.accuracyCalc(newMaxRawCritDamage, newMaxRawDamage, newMinRawDamage, monstersData[newPos].defence);

      if (newMaxDamage >= 1 && !checked) {
        str5 = `You can deal --${Math.floor(newMaxDamage)}-- max damage to --${monstersData[newPos].monster}--!`;
        alrDealDamage = true;
      } else if (newMaxDamage > 1 && !alrDealDamage && !dealDamage) {
        str5 = `You can deal --${Math.floor(newMaxDamage)}-- max damage to --${monstersData[newPos].monster}-- in --${statAdd} stats--!`;
        dealDamage = true;
      }
      checked = true;
      statAdd++;
    }

    if (checkNextMob) {
      str1 = `Max. Damage: --${Math.floor(maxDamage)}-- | Tickrate: --${Math.floor(tickRate)}-- / 3600\n`;
      str2 = `Avg. time to kill ${monstersData[pos].monster}: --${Math.floor(time / 60)} min. ${Math.floor(time % 60)} sec.--\n`;
      str4 = `You need --${statAdd} stats-- to train effectively on --${monstersData[newPos].monster}--!\n`;
    } else {
      str1 = `Min. Damage (Auto): --${Math.floor(minDamage)}-- | Max. Damage (Auto): --${Math.floor(maxDamage)}--\n`;
      str2 = `Avg. time to kill ${monstersData[pos].monster}: --${Math.floor(time / 60)} min. ${Math.floor(time % 60)} sec.--\n`;
    }
    setResult(`-- AFK TRAINING ANALYSIS --\n${header}\n${str0}${str1}${str2}${str3}${str4}${str5}`);
    setOpenDialog(true);
  }

  function tank(base, defence, monster, armour) {
    if (!base || !armour || !defence || monster === "") {
        setResult("Please fill all fields: Base Level, Armor, Defence, and select a Monster.");
        setOpenDialog(true);
        return;
    }

    const baseNum = parseInt(base, 10);
    const defenceNum = parseInt(defence, 10);
    const armourNum = parseInt(armour, 10);

    if (isNaN(baseNum) || isNaN(armourNum) || isNaN(defenceNum)) {
        setResult("Base Level, Defense, and Armor must be valid numbers.");
        setOpenDialog(true);
        return;
    }

    const selectedMonster = monstersData[monster];
    const rawMonsterDamage = Formulas.autoMaxRawDamageCalc(selectedMonster.stat, selectedMonster.atk, selectedMonster.level);

    // New constants and weights based on the latest user feedback
    const DEFENSE_WEIGHT = 1.75;
    const ARMOR_WEIGHT = 0.5;
    const LEVEL_WEIGHT = 0.2;
    const THRESHOLD_DIVISOR = 3.6;
    const DAMAGE_MULTIPLIER = 0.7;

    const defenseThreshold = (rawMonsterDamage * 4) / THRESHOLD_DIVISOR;
    
    const playerMitigationPower = (defenceNum * DEFENSE_WEIGHT) + (armourNum * ARMOR_WEIGHT) + (baseNum * LEVEL_WEIGHT);

    let finalDamage = 0;
    if (playerMitigationPower < defenseThreshold) {
        finalDamage = (defenseThreshold - playerMitigationPower) * DAMAGE_MULTIPLIER;
    }
    
    finalDamage = Math.round(finalDamage);

    let resultString = `-- TANKING ANALYSIS: ${selectedMonster.monster} --\n\n`;
    resultString += `Note: This calculation is for tanking 4 monsters, where your parry is broken. Damage vs a single monster is assumed to be 0 for a player with these stats.\n\n`;
    
    resultString += `-- DAMAGE RECEIVED (vs. 4 monsters) --\n`;
    resultString += `Estimated total damage per round: --${finalDamage.toLocaleString()}--\n\n`;

    const currentPowerNonDef = (armourNum * ARMOR_WEIGHT) + (baseNum * LEVEL_WEIGHT);
    const neededMitigationFromDef = defenseThreshold - currentPowerNonDef;
    const neededDef = neededMitigationFromDef / DEFENSE_WEIGHT;

    resultString += `-- SURVIVAL THRESHOLD (vs. 4 monsters) --\n`;
    if (neededDef <= defenceNum) {
        resultString += `You have surpassed the defense threshold and should take --0 damage-- when surrounded!`;
    } else {
        resultString += `To fully tank (0 damage), you need approximately --${Math.ceil(neededDef).toLocaleString()}-- total defense skill.`;
    }
    
    setResult(resultString);
    setOpenDialog(true);
  }

  function offlineStatCalculator(stat1, stat2, hours) {
    const stat1Num = parseInt(stat1, 10) || 0;
    const stat2Num = parseInt(stat2, 10) || 0;
    const hoursNum = parseInt(hours, 10) || 0;

    if (stat2Num > 0 && hoursNum <= 0) {
      if (stat1Num > stat2Num) {
        setResult("Goal stat must be greater than current stat");
        setOpenDialog(true);
        return;
      }
      const ticks1 = Formulas.offlineticks(stat1Num);
      const ticks2 = Formulas.offlineticks(stat2Num);
      const totalTicks = ticks2 - ticks1;
      const minutes = (totalTicks * 60) / 600;
      const calculatedHours = totalTicks / 600;
      setResult(
        `-- OFFLINE: STAT GOAL --\nInitial: ${stat1Num} | Goal: ${stat2Num}\n\nNeeded: --~${Math.round(
          totalTicks
        ).toLocaleString()} ticks--\nTime: --~${minutes.toFixed(
          1
        )} mins-- / --${calculatedHours.toFixed(1)} hours-- (600 exp/hr)`
      );
      setOpenDialog(true);
    } else if (hoursNum > 0 && stat2Num <= 0) {
      const tickstrained = 600 * hoursNum;
      let ticks1 = Formulas.offlineticks(stat1Num);
      const ticks2 = tickstrained + ticks1;
      const newStat = Math.round(100 * Formulas.findStatLevelCalc(ticks2)) / 100;
      setResult(
        `-- OFFLINE: TIME GOAL --\nInitial: ${stat1Num} | Hours: ${hoursNum}\n\nNew stat approx: --${newStat.toFixed(
          2
        )}--`
      );
      setOpenDialog(true);
    } else {
      setResult("Enter either hours OR goal stat");
      setOpenDialog(true);
    }
  }

  const RUTE = { 1: [16, 8], 2: [17, 13], 3: [6, 13], 4: [7, 23], 5: [11, 6], 6: [9, 7], 7: [9, 6], 8: [19, 22], 9: [7, 21], 10: [22, 24], 11: [20, 7], 12: [7, 18], 13: [16, 12], 14: [21, 15], 15: [1, 22], 16: [15, 10], 17: [15, 22], 18: [9, 4], 19: [25, 17], 20: [9, 3], 21: [5, 12], 22: [15, 17], 23: [1, 9], 24: [14, 17], 25: [2, 15] };
  
  const searchRoute = (from, to, i = 1) => {
    const fromNum = parseInt(from, 10);
    const toNum = parseInt(to, 10);
    
    if (i > 25) { 
        setResult("No route found."); 
        setOpenDialog(true);
        return; 
    }
    const founds = cariRute(fromNum, toNum, i);
    if (founds && founds[0]) {
      setResult(`-- LIZARD MAZE ROUTE --\nFrom Room ${fromNum} to Room ${toNum}\n\nPath: --${founds[0].T}--\n(L = Left, R = Right)\n\nRooms: --${founds[0].R}--`);
      setOpenDialog(true);
      return;
    }
    searchRoute(fromNum, toNum, i + 1);
  };

  function cariRute(from, to, max, path) {
    if (!max) max = 10;
    if (!path) path = { T: "", R: from + " " };
    if (path.T.length >= max) return [];
    let done = false, result = [], sudah = path.R.split(" ").map(el => parseInt(el) || 0);
    if (sudah.indexOf(RUTE[from][0]) < 1 && RUTE[from][0] === to) {
      result.push({ T: path.T + "L", R: path.R + RUTE[from][0] + " " });
      done = true;
    }
    if (sudah.indexOf(RUTE[from][1]) < 1 && RUTE[from][1] === to) {
      result.push({ T: path.T + "R", R: path.R + RUTE[from][1] + " " });
      done = true;
    }
    if (!done || (true && path.T.length < max)) {
      if (sudah.indexOf(RUTE[from][0]) === -1) {
        result = result.concat(cariRute(RUTE[from][0], to, max, { T: path.T + "L", R: path.R + RUTE[from][0] + " " }, true));
      }
      if (sudah.indexOf(RUTE[from][1]) === -1) {
        result = result.concat(cariRute(RUTE[from][1], to, max, { T: path.T + "R", R: path.R + RUTE[from][1] + " " }, true));
      }
    }
    return result;
  }
  
  const dungeonSimData = {
      vampires: { name: "Vampires", dropRate: 0.021737, itemValue: 4500, keyCost: 30000, pickupGold: 50000 },
      drows: { name: "Drows", dropRate: 0.006004, itemValue: 25000, keyCost: 60000, pickupGold: 60000 },
      lizards: { name: "Lizards", dropRate: 0.00249, itemValue: 55000, keyCost: 90000, pickupGold: 70000 },
  };

  function runSimulation() {
    const killRates = {
      vampires: parseInt(vampKills, 10) || 0,
      drows: parseInt(drowKills, 10) || 0,
      lizards: parseInt(lizKills, 10) || 0,
    };

    const dungeonsToSimulate = Object.keys(dungeonSimData)
      .filter(key => killRates[key] > 0)
      .map(key => ({ id: key, ...dungeonSimData[key] }));

    if (dungeonsToSimulate.length === 0) {
      setResult("Please enter a kill rate for at least one dungeon.");
      setOpenDialog(true);
      return;
    }

    const simulationResults = dungeonsToSimulate.map(dungeon => {
      const killsPerHour = killRates[dungeon.id] * 6;
      const itemGoldPerHour = killsPerHour * dungeon.dropRate * dungeon.itemValue;
      const grossGoldPerHour = itemGoldPerHour + dungeon.pickupGold;
      const netProfitPerHour = grossGoldPerHour - dungeon.keyCost;
      const dropsPerHour = killsPerHour * dungeon.dropRate;
      const avgTimePerDrop = dropsPerHour > 0 ? 60 / dropsPerHour : Infinity;

      return { ...dungeon, netProfitPerHour, avgTimePerDrop };
    });
      
    let resultString = "-- FARMING SIMULATION RESULTS --\n(Calculations are per hour)\n\n";
      
    simulationResults.forEach(res => {
      resultString += `[${res.name}]\n`;
      resultString += `Profit: --~${res.netProfitPerHour.toLocaleString(undefined, {maximumFractionDigits: 0})} gold--\n`;
      resultString += `Consistency: ~1 drop every --${res.avgTimePerDrop.toFixed(1)} mins--\n\n`;
    });
      
    const bestOption = simulationResults.sort((a, b) => b.netProfitPerHour - a.netProfitPerHour)[0];
    
    resultString += `-- RECOMMENDATION --\n`;
    resultString += `Based on your kill rates, --${bestOption.name}-- appears to be the most profitable dungeon.`;

    setResult(resultString);
    setOpenDialog(true);
  }

  return (
    <div className="h-screen w-screen flex items-center justify-center">
      <div
        className={`rpg-panel ${themeClass} md:w-[450px] w-[95%] min-h-[400px] flex items-center justify-center flex-col`}
      >
        {page === 'Simulator' && (
             <div className="absolute top-[-15px] left-[-15px] rotate-[-10deg] bg-[#ca8a04] text-black text-[10px] px-3 py-1 border-2 border-black" style={{boxShadow: "inset 2px 2px 0 #ffef82, inset -2px -2px 0 #8c6d06"}}>
                EXPERIMENTAL
             </div>
        )}
        <h1 className="text-2xl mb-6 text-[#fbfaaa] tracking-widest" style={{textShadow: "2px 2px 0 #000"}}>
          <span className="capitalize">{page}</span>
        </h1>

        <div className="flex w-full flex-col gap-1 items-center justify-center">
          
          {page === "Damage" && (
            <>
              <InputGroup label="Base Level" value={base} onChange={(e) => setBase(e.target.value)} />
              <InputGroup label="Weapon Atk" value={weaponAtk} onChange={(e) => setWeaponAtk(e.target.value)} />
              <InputGroup label="Total Stat" value={stat} onChange={(e) => setStat(e.target.value)} />
              
              <div className="rpg-input-group">
                <label className="rpg-label">Monster</label>
                <select className="rpg-select" value={mobId} onChange={handleMonsterChange}>
                   <option value="" disabled>Select Monster</option>
                  {monstersData.map((monster) => (
                    <option key={monster.id} value={monster.id}>{monster.monster}</option>
                  ))}
                </select>
              </div>

              <div className="rpg-input-group">
                <label className="rpg-label">Attack Type</label>
                <select className="rpg-select" value={attackType} onChange={(e) => setAttackType(e.target.value)}>
                  <option value="auto">Auto</option>
                  <option value="special">Special</option>
                  <option value="magic">Special Magic</option>
                </select>
              </div>
              <ActionButton onClick={handleCalculateClick} />
            </>
          )}

          {page === "Grind" && (
            <>
              <InputGroup label="Current Level" value={base} onChange={(e) => setBase(e.target.value)} />
              <InputGroup label="Exp Per Hour" value={grindrate} onChange={(e) => setGrindrate(e.target.value)} />
              <InputGroup label="Goal Level" value={basegoal} onChange={(e) => setBasegoal(e.target.value)} />
              <ActionButton onClick={() => handleGrind(base, basegoal, grindrate > 0 ? grindrate : 2000000)} />
            </>
          )}

          {page === "Skull" && (
            <>
              <InputGroup label="Current Level" value={base} onChange={(e) => setBase(e.target.value)} />
              <ActionButton onClick={() => skull(base)} />
            </>
          )}

          {page === "Power Train" && (
            <>
              <InputGroup label="Base Level" value={base} onChange={(e) => setBase(e.target.value)} />
              <div className="rpg-input-group">
                  <label className="rpg-label">Class</label>
                  <select className="rpg-select" value={classm} onChange={(e) => setClassm(e.target.value)}>
                    <option value="melee">Melee</option>
                    <option value="magic">Magic</option>
                    <option value="distance">Distance</option>
                  </select>
              </div>
              <InputGroup label="Stat" value={stat} onChange={(e) => setStat(e.target.value)} />
              <InputGroup label="Weapon Atk" value={weaponAtk} onChange={(e) => setWeaponAtk(e.target.value)} />
              <ActionButton onClick={() => ptrain(classm, base, stat, buffs, weaponAtk, tick)} />
            </>
          )}

          {page === "Stat" && (
            <>
              <InputGroup label="Current Stat" value={stat1} onChange={(e) => setStat1(e.target.value)} />
              <InputGroup label="Goal Stat" value={stat2} onChange={(e) => setStat2(e.target.value)} />
              
              <div className="w-[90%] my-3 pt-3 border-t border-gray-700 space-y-2">
                  <p className="text-sm text-gray-400 text-center w-full mb-2 rpg-label">SKILL BUFFS</p>
                  <div className="flex items-center gap-3 pl-2">
                    <input type="checkbox" id="bonusStamina" checked={bonusStamina} onChange={(e) => setBonusStamina(e.target.checked)} style={{width: '16px', height: '16px'}} />
                    <label htmlFor="bonusStamina" className="text-gray-300 font-[VT323] text-lg">Bonus Stamina (1.5x)</label>
                  </div>
                  <div className="flex items-center gap-3 pl-2">
                    <input type="checkbox" id="onlineTraining" checked={onlineTraining} onChange={(e) => setOnlineTraining(e.target.checked)} style={{width: '16px', height: '16px'}}/>
                    <label htmlFor="onlineTraining" className="text-gray-300 font-[VT323] text-lg">Online Training (2x)</label>
                  </div>
                  <div className="flex items-center gap-3 pl-2">
                    <input type="checkbox" id="doubleSkillPotion" checked={doubleSkillPotion} onChange={(e) => setDoubleSkillPotion(e.target.checked)} style={{width: '16px', height: '16px'}}/>
                    <label htmlFor="doubleSkillPotion" className="text-gray-300 font-[VT323] text-lg">Double Skill Potion (2x)</label>
                  </div>
              </div>

              <ActionButton onClick={() => {
                  const res = calculateStat(stat1, stat2, bonusStamina, onlineTraining, doubleSkillPotion);
                  setResult(res);
                  setOpenDialog(true);
              }} />
            </>
          )}

          {page === "Lizard Route" && (
            <>
              <InputGroup label="Current Room" value={from} onChange={(e) => setFrom(e.target.value)} />
              <InputGroup label="Destination Room" value={to} onChange={(e) => setTo(e.target.value)} />
              <ActionButton onClick={() => searchRoute(from, to)} />
            </>
          )}

          {page === "Afk train" && (
            <>
              <InputGroup label="Base Level" value={afkBase} onChange={(e) => setAfkBase(e.target.value)} />
              <InputGroup label="Stat" value={afkStat} onChange={(e) => setAfkStat(e.target.value)} />
              <InputGroup label="Weapon Atk" value={afkWeaponAtk} onChange={(e) => setAfkWeaponAtk(e.target.value)} />
              <ActionButton onClick={() => train(afkBase, afkStat, afkWeaponAtk)} />
            </>
          )}
          
          {page === "Simulator" && (
             <>
                <p className="text-xs text-gray-400 text-center w-[90%] mb-4 font-[VT323] leading-relaxed">Go in-game and count your kills in each dungeon for 10 minutes. You can leave fields blank.</p>
                <InputGroup label="Vampire Kills (in 10 min)" value={vampKills} onChange={(e) => setVampKills(e.target.value)} />
                <InputGroup label="Drow Kills (in 10 min)" value={drowKills} onChange={(e) => setDrowKills(e.target.value)} />
                <InputGroup label="Lizard Kills (in 10 min)" value={lizKills} onChange={(e) => setLizKills(e.target.value)} />
                <ActionButton onClick={runSimulation} label="Run Simulation" colorClass="gold" />
             </>
          )}

          {page === "Offline" && (
            <>
              <InputGroup label="Current Stat" value={currentStat} onChange={(e) => setCurrentStat(e.target.value)} />
              <InputGroup label="Goal Stat" disabled={hours > 0} value={goalStat} onChange={(e) => setGoalstat(e.target.value)} />
              <InputGroup label="Offline Hours" disabled={goalStat > 0} value={hours} onChange={(e) => setHours(e.target.value)} />
              <ActionButton onClick={() => offlineStatCalculator(currentStat, goalStat, hours)} />
            </>
          )}

          {page === "Tank Monster" && (
            <>
               <InputGroup label="Base Level" value={base} onChange={(e) => setBase(e.target.value)} />
               <InputGroup label="Total Defence" value={defence} onChange={(e) => setDefence(e.target.value)} />
               <InputGroup label="Armor" value={armour} onChange={(e) => setArmour(e.target.value)} />
               <div className="rpg-input-group">
                <label className="rpg-label">Monster</label>
                <select className="rpg-select" value={mobId} onChange={handleMonsterChange}>
                   <option value="" disabled>Select Monster</option>
                  {monstersData.map((monster) => (
                    <option key={monster.id} value={monster.id}>{monster.monster}</option>
                  ))}
                </select>
              </div>
              <ActionButton onClick={() => tank(base, defence, mobId, armour)} />
            </>
          )}

          {page === "Potion Cost" && (
            <>
              <InputGroup label="Number of Pots" value={numpots} onChange={(e) => setNumpots(e.target.value)} />
              <ActionButton onClick={() => potions(numpots)} />
            </>
          )}

          {page === "Exp" && (
            <>
              <InputGroup label="Current Level" value={goalLevel} onChange={(e) => setGoalLevel(e.target.value)} />
              <ActionButton onClick={() => exp(goalLevel)} />
            </>
          )}
        </div>

        <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle id="scroll-dialog-title">SYSTEM MESSAGE</DialogTitle>
            <DialogContent dividers>
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                    dangerouslySetInnerHTML={{
                        __html: result
                            .replace(/--(.+?)--/g, "<b>$1</b>")
                            .replace(/\n/g, "<br/>"),
                    }}
                ></DialogContentText>
            </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default Main;